import { useMutation } from '@tanstack/react-query';
import { verifyMfa } from '../api/autoLogin.api';
import type { UseMutationOptions } from '@tanstack/react-query';
import type { VerifyMfaPayload } from '../api/autoLogin.api';

type UseVerifyMfaParams = Omit<
  UseMutationOptions<unknown, unknown, VerifyMfaPayload>,
  'mutationFn' | 'mutationKey'
>;

export const useVerifyMfa = ({ onSuccess, onError, onSettled }: UseVerifyMfaParams = {}) => {
  const {
    mutateAsync: asyncVerifyMfa,
    isPending: isLoadingVerifyMfa,
    data: verifyMfaResponse,
  } = useMutation({
    mutationFn: verifyMfa,
    mutationKey: ['verifyMfa'],
    onSuccess,
    onError,
    onSettled,
  });

  return {
    asyncVerifyMfa,
    isLoadingVerifyMfa,
    verifyMfaResponse,
  };
};
